import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import {
  useAddAgencyProduct,
  useGetAgencyProducts,
  useRemoveAgencyProduct,
  useUpdateAgencyProducts,
} from '~/hooks/agencies';
import { useGetProductsList } from '~/hooks/products';
import AgencyProductsTable from '~/components/table/AgencyProductsTable';
import selectStyles from '~/components/FilterSearchParam/styles';
import type { IOption } from '~/types/options';
import styles from './products.module.scss';

const AgencyProducts = () => {
  const { id = '' } = useParams();
  const { data: products = [] } = useGetAgencyProducts({ id });
  const { data: productsList } = useGetProductsList();
  const { mutate: addAgencyProduct } = useAddAgencyProduct('Produit associé');
  const { mutate: removeAgencyProduct } = useRemoveAgencyProduct('Produit dissocié');
  const { mutate: updateAgencyProducts } = useUpdateAgencyProducts('Tarif mis à jour');

  const options = useMemo<IOption[]>(
    () => (productsList?.products || []),
    [productsList],
  );
  const [selectedProduct, setSelectedProduct] = useState<IOption | null>(null);

  return (
    <div className={styles.products}>
      <div className={styles.header}>
        <div className={styles.associate}>
          <Select
            value={selectedProduct}
            options={options}
            styles={selectStyles}
            placeholder='Associer un produit…'
            onChange={(opt) => setSelectedProduct(opt as IOption)}
            isSearchable={true}
            classNamePrefix="react-select"
          />
          <button
            disabled={!selectedProduct?.value}
            onClick={() => {
              addAgencyProduct({ _id: id, productId: String(selectedProduct?.value) });
              setSelectedProduct(null);
            }}
          >
            Associer
          </button>
        </div>
      </div>

      <AgencyProductsTable
        rows={products || []}
        onUpdate={({ productId, key, value }) => updateAgencyProducts({
          _id: id,
          productId,
          key,
          value,
        })}
        onRemove={(productId) => removeAgencyProduct({ _id: id, productId })}
      />
    </div>
  );
};

export default AgencyProducts;
